import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { purchasedPackagewith3dsecurity } from "../../redux/auth/saga";
import { Loader } from "../../components";

const PaymentSuccess = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(true);
  const history = useNavigate();
  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const status = query.get("status");
    const mdstatus = query.get("mdstatus");
    const paymentid = query.get("paymentid");
    const conversationdata = query.get("conversationdata");
    const conversationid = query.get("conversationid");
    if (mdstatus === "1") {
      dispatch(
        purchasedPackagewith3dsecurity({
          payload: {
            onSuccess: async (message, payload) => {
              history("?result=success");
              window.parent.postMessage("token=" + payload);
              setLoader(false);
            },
            onError: async (message, error) => {
              history("?result=failed");
              window.parent.postMessage("error=" + message);
              setLoader(false);
            },
          },
          body: {
            PaymentId: paymentid,
            ConversationId: conversationid,
            ConversationData: conversationdata,
          },
        })
      );
    } else {
      setLoader(false);
      history("?result=failed");
      window.parent.postMessage("error=" + mdstatus);
    } // eslint-disable-next-line
  }, [dispatch]);
  return (
    <div>
      <div
        style={{
          left: 0,
          top: 0,
          right: 0,
          bottom: 0,
          position: "fixed",
          zIndex: 1051,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#fff",
        }}
      >
        {loader && <Loader />}
      </div>
    </div>
  );
};
export default PaymentSuccess;
